<script>
  import { onDestroy } from 'svelte';
  import UserAjax from '@ajax/user';
  import { getCurrentUserStore } from '@stores/current_user';
  import Nudge from '@utils/nudge';

  export let toggleOptionsMenu;
  export let icon;
  export let group;

  let user = getCurrentUserStore('default');
  user.subscribe((x) => (user = x));

  let nudgeMenuCurrentUser = Nudge.get('menu_current_user');
  let unsubNudge = Nudge.subscribe('menu_current_user', (showHide) => (nudgeMenuCurrentUser = showHide));

  $: dropDownShowRedDot = (!group && user.profile_menu_active) || nudgeMenuCurrentUser;

  const handleMainMenuClicked = function () {
    if (user.profile_menu_active) {
      UserAjax.setProfileMenuClicked(user);
      user.set({ ...user, profile_menu_active: false });
    }

    Nudge.hide(user, 'menu_current_user');
    toggleOptionsMenu();
  };

  onDestroy(() => {
    unsubNudge && unsubNudge();
  });
</script>

<style style="text/scss" lang="scss">
  .m-gear {
    width: 4px;
    height: 16px;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    padding-left: 35px;
    padding-top: 5px;
    padding-right: 5px;

    &.hamburger {
      padding-right: 15px;
      padding-top: 0px;
      padding-left: 0px;
      width: 24px;
      height: 24px;
    }
  }
</style>

<div class="m-gear {icon}" on:click={() => handleMainMenuClicked()}>
  {#if dropDownShowRedDot}
    <div class="navigation-red-dot" style="right: -5px; top: calc(50% - 12px);" />
  {/if}
  <a href>
    {#if icon == 'hamburger'}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.25 18.003H21.75" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.25 12.003H21.75" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.25 6.00299H21.75" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    {:else}
      <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2C4 3.10457
    3.10457 4 2 4C0.895431 4 0 3.10457 0 2ZM0 14C0 12.8954 0.895431 12 2
    12C3.10457 12 4 12.8954 4 14C4 15.1046 3.10457 16 2 16C0.895431 16 0
    15.1046 0 14ZM2 6C0.895431 6 0 6.89543 0 8C0 9.10457 0.895431 10 2
    10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6Z"
          fill="#000000" />
      </svg>
    {/if}
  </a>
</div>
